import fetch from "auth/FetchInterceptor"

const GroupsService = {}

const groupEndpointPrefix = "/groups"

// Filtre "status" accepté par GET /groups/getAll :
//  - encours  => finished: { $ne: true } (inclut les groupes créés avant le champ)
//  - finished => groupes terminés
//  - all / vide => aucun filtre
// Le back accepte des alias, on les normalise ici pour n'envoyer que la valeur canonique.
export const GROUP_STATUS_ALL = "all"
export const GROUP_STATUS_ONGOING = "encours"
export const GROUP_STATUS_FINISHED = "finished"

const GROUP_STATUS_ALIASES = {
  encours: GROUP_STATUS_ONGOING,
  ongoing: GROUP_STATUS_ONGOING,
  active: GROUP_STATUS_ONGOING,
  "en-cours": GROUP_STATUS_ONGOING,
  en_cours: GROUP_STATUS_ONGOING,
  finished: GROUP_STATUS_FINISHED,
  termine: GROUP_STATUS_FINISHED,
  terminé: GROUP_STATUS_FINISHED,
  completed: GROUP_STATUS_FINISHED,
}

/**
 * Renvoie "encours" | "finished" | "all" (valeur inconnue => "all", pour ne pas
 * provoquer un 400 côté API).
 */
export const normalizeGroupStatus = (status) => {
  if (!status) return GROUP_STATUS_ALL
  const key = String(status).trim().toLowerCase()
  if (!key || key === GROUP_STATUS_ALL) return GROUP_STATUS_ALL
  return GROUP_STATUS_ALIASES[key] || GROUP_STATUS_ALL
}

GroupsService.getGroups = async (params = {}) => {
  const queryParams = new URLSearchParams()
  if (params.page) queryParams.append("page", params.page)
  if (params.limit) queryParams.append("limit", params.limit)
  if (params.instructorId && params.instructorId !== "all") {
    queryParams.append("instructorId", params.instructorId)
  }
  const status = normalizeGroupStatus(params.status)
  if (status !== GROUP_STATUS_ALL) {
    queryParams.append("status", status)
  }
  if (params.formationName) {
    queryParams.append("formationName", params.formationName)
  }
  if (params.formateurName) {
    queryParams.append("formateurName", params.formateurName)
  }
  if (params.groupName) {
    queryParams.append("groupName", params.groupName)
  }
  if (params.isForTraining !== undefined) {
    queryParams.append("isForTraining", params.isForTraining)
  }
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : ""
  return fetch(`${groupEndpointPrefix}/getAll${queryString}`, {
    method: "GET",
  })
}

GroupsService.getGroupById = async (id) =>
  await fetch(`${groupEndpointPrefix}/${id}`, {
    method: "GET",
  })

GroupsService.getTrainingGroupsById = async (id) =>
  await fetch(`${groupEndpointPrefix}/training/${id}`, {
    method: "GET",
  })

GroupsService.getSupportCourseGroupsById = async (id) =>
  await fetch(`${groupEndpointPrefix}/supportCourse/${id}`, {
    method: "GET",
  })

GroupsService.createTrainingGroup = async (data) =>
  await fetch(`${groupEndpointPrefix}/training`, {
    method: "POST",
    data,
  })

GroupsService.createSupportCourseGroup = async (data) =>
  await fetch(`${groupEndpointPrefix}/supportCourse`, {
    method: "POST",
    data,
  })

GroupsService.updateGroupStudents = async (groupId, data) =>
  await fetch(`${groupEndpointPrefix}/${groupId}/students`, {
    method: "PATCH",
    data,
    headers: {
      "Content-Type": "application/json",
    },
  })

GroupsService.addFormerToGroup = async (id, { formateurId, paymentType, paymentValue }) =>
  await fetch(`${groupEndpointPrefix}/${id}/instructor`, {
    method: "PATCH",
    data: { formateurId, paymentType, paymentValue },
  })

GroupsService.deleteFormerById = async (id, data) =>
  await fetch(`${groupEndpointPrefix}/${id}/instructor`, {
    method: "DELETE",
    data,
  })

GroupsService.deleteGroup = async (id) =>
  await fetch(`${groupEndpointPrefix}/${id}`, {
    method: "DELETE",
  })

GroupsService.toggleFinished = async (groupId) =>
  await fetch(`${groupEndpointPrefix}/${groupId}/finished`, {
    method: "PATCH",
  })

GroupsService.updateAdminSession = async (groupId, sessionData) =>
  await fetch(`${groupEndpointPrefix}/${groupId}/admin-session`, {
    method: "PATCH",
    data: sessionData,
  })

GroupsService.startSession = async (groupId, data = {}) =>
  await fetch(`${groupEndpointPrefix}/${groupId}/start-session`, {
    method: "PATCH",
    data,
  })

GroupsService.pauseSession = async (groupId, data = {}) =>
  await fetch(`${groupEndpointPrefix}/${groupId}/pause-session`, {
    method: "PATCH",
    data,
  })

GroupsService.completeSession = async (groupId, data = {}) =>
  await fetch(`${groupEndpointPrefix}/${groupId}/complete-session`, {
    method: "PATCH",
    data,
  })

  GroupsService.updateGroupName = async (id, groupName) =>
  await fetch(`${groupEndpointPrefix}/${id}/name`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ groupName }),
  });

export default GroupsService
